(function(){
  'use strict';

  function initCategoryFilter() {
    var filterBtns = document.querySelectorAll('.omesa-journal-filter__btn');
    var articles   = document.querySelectorAll('.omesa-journal-grid__article');
    if (!filterBtns.length) return;
    filterBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var category = btn.dataset.category;
        filterBtns.forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        articles.forEach(function(article) {
          if (category === 'all' || article.dataset.category === category) {
            article.classList.remove('is-hidden');
          } else {
            article.classList.add('is-hidden');
          }
        });
      });
    });
  }

  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-omesa-animate]').forEach(function(el) {
        el.classList.add('omesa-animate--visible');
      });
      return;
    }
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('omesa-animate--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    document.querySelectorAll('[data-omesa-animate]').forEach(function(el) {
      observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initCategoryFilter();
    initScrollAnimations();
  });
})();
